import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

export default (el, props) => {
    const $el = $(el);
    const $panelsToggle = $el.find('[data-panel-toggle]');
    const $panel = $el.find('[data-panel]');
    const $filterGroupToggles = $el.find('[data-filtergroup-toggle]');
    const $filterGroups = $el.find('[data-categorygroup]');
    const $btn = $el.find('[data-show-results-btn]');
    
    let panelOpen = false;

    const onResize = e => {
        e.preventDefault();
        
    };
    
    const showResults = () => {
        // todo : Could be improved with ajax
        togglePanel();
    };
    
    const toggleGroup = e => {
        const $trigger = $(e.triggerTarget);
        const $target = $el.find($trigger.attr('href'));
        
        if ($target.length > 0) {
            $filterGroups.css({ display: 'none' });
            $target.css({ display: 'block' });
            
            $filterGroupToggles.removeClass('is-selected');
            $trigger.addClass('is-selected');
        }
    };
    
    const togglePanel = () => {
        if (panelOpen) {
            $panel.css({ height: '', overflow: 'hidden' });
        } else {
            $panel.css({ height: '100%', overflow: 'auto' });
        }
        
        panelOpen = !panelOpen;
    };
    
    const reset = () => {
        //$panel.css({ height: '100%', display: 'none' });
        
    };

    const init = () => {
        reset();
        
        $panelsToggle.on('click', (e) => {
            e.preventDefault();
            togglePanel();
        });
        
        $filterGroupToggles.on('click', (e) => {
            e.preventDefault();
            toggleGroup(e);
        });
        
        $btn.on('click', (e) => {
            showResults();
        });
        
        Viewport.on('resize', onResize);
    };

    const destroy = () => {

        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ProductFilter.js